import React from 'react';

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/


var classnames = createCommonjsModule(function (module) {
  /* global define */
  (function () {
    var hasOwn = {}.hasOwnProperty;

    function classNames() {
      var classes = [];

      for (var i = 0; i < arguments.length; i++) {
        var arg = arguments[i];
        if (!arg) continue;
        var argType = typeof arg;

        if (argType === 'string' || argType === 'number') {
          classes.push(arg);
        } else if (Array.isArray(arg) && arg.length) {
          var inner = classNames.apply(null, arg);

          if (inner) {
            classes.push(inner);
          }
        } else if (argType === 'object') {
          for (var key in arg) {
            if (hasOwn.call(arg, key) && arg[key]) {
              classes.push(key);
            }
          }
        }
      }

      return classes.join(' ');
    }

    if (module.exports) {
      classNames.default = classNames;
      module.exports = classNames;
    } else {
      window.classNames = classNames;
    }
  })();
});
var modules_39fbd8cc = {
  "grid": "Grid_module_grid__da3b8c09",
  "grid__item": "Grid_module_grid__item__da3b8c09",
  "grid--1": "Grid_module_grid_1__da3b8c09",
  "grid--2": "Grid_module_grid_2__da3b8c09",
  "grid--3": "Grid_module_grid_3__da3b8c09",
  "grid--4": "Grid_module_grid_4__da3b8c09"
};

var Row = function Row(_ref) {
  var _cx;

  var className = _ref.className,
      cols = _ref.cols,
      customCols = _ref.customCols,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(modules_39fbd8cc.grid, (_cx = {}, _cx[modules_39fbd8cc["grid--" + cols]] = cols && !customCols && modules_39fbd8cc["grid--" + cols], _cx), className)
  }, children);
};

Row.displayName = "Row";

var Cell = function Cell(_ref2) {
  var className = _ref2.className,
      children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(modules_39fbd8cc.grid__item, className)
  }, children);
};

Cell.displayName = "Cell";
Row.defaultProps = {
  className: undefined,
  cols: undefined,
  customCols: undefined
};
Cell.defaultProps = {
  className: undefined
};
export { Cell, Row };